import { useState } from 'react';

const letters = [
  {
    from: '김지원',
    role: 'CEO, LUMIÈRE Beauty',
    date: '2024년 3월 15일',
    text: 'caratings와 함께한 6개월은 우리 브랜드에 있어 전환점이었습니다. 단순한 광고 집행이 아닌, 시장을 깊이 이해하는 전략 파트너를 만난 것입니다. 브랜드 인지도 240% 상승이라는 수치가 그 증거입니다.',
    result: '브랜드 인지도 +240%',
  },
  {
    from: '박승호',
    role: 'CMO, MODO Fashion',
    date: '2023년 11월 20일',
    text: '인스타그램 계정을 처음 열었을 때, 8개월 안에 12만 팔로워를 달성할 것이라고는 상상도 못 했습니다. caratings의 데이터 기반 콘텐츠 전략이 없었다면 불가능했을 일입니다.',
    result: '팔로워 120,000 달성',
  },
  {
    from: '이선영',
    role: 'Director, HomeStyle Co.',
    date: '2023년 8월 7일',
    text: '처음에는 반신반의했습니다. ROAS 6.2배라는 목표가 현실적으로 가능한지 의심스러웠기 때문입니다. 하지만 결과가 모든 것을 말해줬습니다. 광고비를 절감하면서 매출이 올랐습니다.',
    result: 'ROAS 1.8× → 6.2×',
  },
  {
    from: '최민호',
    role: 'Founder, GreenLeap',
    date: '2022년 6월 30일',
    text: '스타트업 초기부터 브랜딩 방향을 잡아준 caratings 덕분에 투자자들에게 강한 인상을 줄 수 있었습니다. 80억 시리즈A 유치는 좋은 브랜드 스토리가 있었기에 가능했습니다.',
    result: '시리즈A 80억 유치',
  },
];

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const r = letters[idx];

  return (
    <section className="py-16 border-b-4 border-ink">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-4 mb-2">
          <div className="bg-ink text-paper font-sans text-xs font-black tracking-widest px-3 py-1.5 uppercase">
            독자 편지
          </div>
          <div className="border-t border-rule-2 flex-1" />
          <span className="font-mono text-xs text-dim">LETTERS TO THE EDITOR</span>
        </div>
     
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 border border-rule-2">
          {/* Index column */}
          <div className="lg:col-span-3 border-b lg:border-b-0 lg:border-r border-rule-2">
            <div className="p-4 bg-paper-2 border-b border-rule-2">
              <p className="font-mono text-xs text-dim uppercase tracking-widest">발신인 목록</p>
            </div>
            {letters.map((l, i) => (
              <button key={l.from} onClick={() => setIdx(i)}
                className="w-full text-left p-4 border-b border-rule-2 last:border-0 transition-colors duration-150 group"
                style={{ background: idx===i ? '#1A1818' : 'transparent' }}>
                <div className="font-sans font-semibold text-sm mb-0.5 transition-colors duration-150"
                  style={{ color: idx===i ? '#F7F4EF' : '#1A1818' }}>
                  {l.from}
                </div>
                <div className="font-mono text-xs transition-colors duration-150"
                  style={{ color: idx===i ? 'rgba(247,244,239,0.5)' : '#6B6B6B' }}>
                  {l.role}
                </div>
                {idx===i && (
                  <div className="mt-2 font-mono text-xs text-red">{l.result}</div>
                )}
              </button>
            ))}
          </div>

          {/* Letter content */}
          <div className="lg:col-span-9 p-8">
            {/* Letter header */}
            <div className="border-b-2 border-ink pb-4 mb-6">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <p className="font-mono text-xs text-dim">발신: {r.from} ({r.role})</p>
                  <p className="font-mono text-xs text-dim">수신: THE CARATINGS 편집국</p>
                  <p className="font-mono text-xs text-dim">날짜: {r.date}</p>
                </div>
                <div className="border-2 border-red px-3 py-1.5">
                  <span className="font-mono text-xs text-red font-bold">{r.result}</span>
                </div>
              </div>
            </div>

            {/* Letter body */}
            <p className="font-serif text-lg leading-relaxed text-ink mb-8">{r.text}</p>

            {/* Signature */}
            <div className="border-t border-rule-2 pt-4 flex items-center justify-between">
              <div>
                <p className="font-headline font-bold italic text-xl text-ink">{r.from}</p>
                <p className="font-mono text-xs text-dim">{r.role}</p>
              </div>
              {/* Dot navigation */}
              <div className="flex gap-2">
                {letters.map((_, i) => (
                  <button key={i} onClick={() => setIdx(i)}
                    className="transition-all duration-200"
                    style={{
                      width: idx===i ? '24px' : '8px',
                      height: '8px',
                      background: idx===i ? '#C8102E' : '#C8B8A2',
                    }} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
